export default __webpack_public_path__ + "static/media/CATonic.93b0c69f2d3fc6eb0c19bfa3dbfc8a42.webp";